export enum ColorPropertyType {
    FillerColor = 'fillerColor',
    WordColor = 'wordColor',
    GridColor = 'gridColor',
    HighlightColor = 'highlightColor',
    HighlightStrokeColor = 'highlightStrokeColor',
    BackgroundColor = 'backgroundColor'
}
